import { isNil } from "lodash";
import React from "react";
import { isMobile } from "react-device-detect";
import classNames from "classnames";

const DeviceInfo = (props) => {
  const { sessions, onSignOut, isNativeApp } = props;

  const allSessions = !isNil(sessions) && sessions.map((session) => {
    return (
      <div className="col__12-12 u--paddingNone-horizontal u--paddingNone-bottom device-info u--marginSmall-bottom" key={session.sessionId}>
        <div className={classNames("col__7-12 col__8-12--sm col__9-12--md col__9-12--lg device-info--location", { "mobile" : isMobile })}>
          <span className="col__12-12 col__12-12--sm col__11-12--md u--paddingNone-top">
            <p>
              <span className="u__bold device-name u--paddingTiny-right">{session.deviceOS? session.deviceOS : "device"}</span>
              {
                session.deviceCity && session.deviceRegion && session.deviceCountry
                  ?
                  <span>
                    <span className="u--paddingTiny-left divider"> | </span>
                    <span>
                      <span> Near </span>
                      <span className="device-name">{session.deviceCity.toLowerCase()}</span>
                      <span className="u--paddingXsmall-left device-country">{session.deviceRegion}, </span>
                      <span className="device-name">{session.deviceCountry}</span>
                    </span>
                  </span>
                  :
                  <span className="u--paddingTiny-left">&nbsp;</span>
              }
            </p>
            <p className={`u--marginXsmall-top ${session.current ? "current" : ""}`}>
              {session.formattedTime}
            </p>
          </span>
        </div>

        {(isNativeApp() && session.current) ? null : <div className="col__5-12 col__4-12--sm col__3-12--md col__3-12--lg security-button signout-button u--paddingNormal-right">
          <button className="bttn-outline bttn-outline--primary bttn-outline--dark" onClick={() => onSignOut(session)}>
            <span className="bttn__content u__small">Sign Out</span>
          </button>
        </div> }
      </div>
    )
  });

  return (
    <div>
      { allSessions }
    </div>
  )
};

export default DeviceInfo;
